import DataDisplayRowI from "../DataDisplayRowI";
import getKPIRow from "../DataDisplayRow/KPIRow";
import DataDisplayTable from "../DataDisplayTable";

export enum KPITypes {
    CURRENT = "current",
    HISTORY = "history",
}

class KPITable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getKPIRow()
    }
}

let kpiTable: KPITable | null = null;

export default function getKPITAble(): KPITable {
    if (kpiTable === null)
        kpiTable = new KPITable()
    return kpiTable
}